import { getDefaultExportFromCjs } from "./_commonjsHelpers.mjs";
import { __require as requireEventemitter3 } from "../node_modules/eventemitter3/index.mjs";
var eventemitter3Exports = requireEventemitter3();
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
export {
  EventEmitter as default
};
//# sourceMappingURL=index.mjs.map
